import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
// import logo from '../styles/logo.png'; // Ensure this file exists

function Home() {
  return (
    <div className="home-backdrop">
      {/* <div className="navbar">
        <img src={logo} alt="AI ASAP Solutions Logo" className="logo" />
        <div>
          <Link to="/">Home</Link>
          <Link to="/products">Products</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div> */}
      
      <div className="container">
        <div className="content">
        <p>
            Deliver cutting edge technology products to elevate customer experience and solve problems.<br />
            Our mission is to provide innovative solutions that meet the needs of our clients.<br />
            We strive to exceed expectations and deliver exceptional value through our products and services.<br /> 
        </p>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <h2>Our Products</h2>
          <div className="products">
            <div className="product1">
              <h3>TN Tender</h3>
              <p>Subscribe to daily WhatsApp updates</p>
              <Link to="/tenderform" className="btn btn-primary">Subscribe</Link>
            </div>
            <div className="product2">
              <h3>TN Auction</h3>
              <p>Subscribe to daily WhatsApp updates</p>
              <Link to="/auctionform" className="btn btn-primary">Subscribe</Link>
            </div>
            <div className="product3">
              <h3>Cake Design</h3>
              <p>Follow the link to login to our page</p>
              <Link to="/cakeapp" className="btn btn-primary">Click</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;